module.exports = __webpack_public_path__ + "img/farzana-christopher-64.1ee2af9f.jpg";